import { routes } from '../constants';
import { FeatureToggle } from '../enums';
import { NavMenuItem } from '../types';

export const NAV_ITEMS: Array<NavMenuItem> = [
  {
    title: 'app.dashboard.sidebar.registry',
    path: routes.DASHBOARD.REGISTRY.GIT_REPOSITORIES,
    svgIcon: 'kube',
  },
  {
    title: 'app.dashboard.sidebar.runtime_environments',
    path: routes.DASHBOARD.RUNTIME_ENVIRONMENTS.ROOT,
    svgIcon: 'environments',
  },
  {
    title: 'app.dashboard.sidebar.decision_records',
    path: routes.DASHBOARD.DECISION_RECORDS,
    svgIcon: 'decision_record',
    feature: FeatureToggle.DECISION_RECORDS,
  },
];

export const USER_NAV_ITEMS_KEYS: Record<string, string> = {
  TEAM_MANAGEMENT:
    'app.dashboard.header.user_menu.workspace.links.team_management',
  USER_PROFILE: 'app.dashboard.header.user_menu.account.links.profile',
  TOKEN_MANAGEMENT:
    'app.dashboard.header.user_menu.workspace.links.token_management',
  PAYMENT: 'app.dashboard.header.user_menu.workspace.links.payment',
  USAGE: 'app.dashboard.header.user_menu.workspace.links.usage',
  SETTINGS: 'app.dashboard.header.user_menu.workspace.links.settings',
  PASSWORD_AUTH: 'app.dashboard.account.general.links.password_auth',
};

export const USER_NAV_ITEMS: Record<string, Array<NavMenuItem>> = {
  'app.dashboard.header.user_menu.account.title': [
    {
      title: USER_NAV_ITEMS_KEYS.USER_PROFILE,
      path: routes.DASHBOARD.ACCOUNT.PROFILE,
      svgIcon: 'user',
    },
  ],
  'app.dashboard.header.user_menu.workspace.title': [
    {
      title: USER_NAV_ITEMS_KEYS.TEAM_MANAGEMENT,
      path: routes.DASHBOARD.ACCOUNT.TEAM_MANAGEMENT,
      svgIcon: 'invite_user',
    },
    {
      title: USER_NAV_ITEMS_KEYS.TOKEN_MANAGEMENT,
      path: routes.DASHBOARD.ACCOUNT.TOKEN_MANAGEMENT,
      svgIcon: 'key',
    },
    {
      title: USER_NAV_ITEMS_KEYS.SETTINGS,
      path: routes.DASHBOARD.ACCOUNT.SETTINGS,
      svgIcon: 'switch',
    },
  ],
  'app.dashboard.account.general.title': [
    {
      title: USER_NAV_ITEMS_KEYS.PASSWORD_AUTH,
      path: routes.DASHBOARD.ACCOUNT.PASSWORD_AUTH,
      svgIcon: 'key',
    },
    {
      title: USER_NAV_ITEMS_KEYS.USAGE,
      path: routes.DASHBOARD.ACCOUNT.USAGE,
      svgIcon: 'usage',
    },
  ],
};
